import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["name", "label"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import styled from 'styled-components';
import Box from '../layout/Box';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var LabelWrapper = styled(Box).attrs({
  $px: 4,
  $mb: [16, null],
  $styles: {
    width: 328,
    position: 'relative'
  }
}).withConfig({
  displayName: "InputLabel__LabelWrapper",
  componentId: "sc-18ul5zg-0"
})([""]);
var Input = styled.input.withConfig({
  displayName: "InputLabel__Input",
  componentId: "sc-18ul5zg-1"
})(["position:relative;display:block;box-sizing:border-box;width:100%;margin-bottom:-1px;border:1px solid ", ";font-family:", ";font-weight:normal;appearance:none;outline:none;color:", ";transition:border 250ms;background:", ";", " &:focus{", ";border:none;}&:focus ~ label{", ";}"], function (props) {
  return props.theme.colors.dimmedGray;
}, function (props) {
  return props.theme.fonts.formular;
}, function (props) {
  return props.theme.colors.primaryIndigo;
}, function (props) {
  return props.theme.colors.primaryWhite;
}, function (props) {
  return props.theme.normalizeStyles({
    paddingTop: 0,
    paddingBottom: 0,
    paddingLeft: 24,
    paddingRight: 24,
    borderRadius: props.theme.spaces.xl,
    height: 56,
    fontSize: 18,
    lineHeight: 24
  });
}, function (_ref) {
  var theme = _ref.theme;
  return theme.normalizeStyles({
    paddingTop: 15
  });
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.normalizeStyles({
    top: 3,
    fontSize: 14,
    lineHeight: 18,
    opacity: 1
  });
});
var Label = styled.label.withConfig({
  displayName: "InputLabel__Label",
  componentId: "sc-18ul5zg-2"
})(["position:absolute;color:", ";", ";"], function (props) {
  return props.theme.colors.dimmedGray;
}, function (_ref3) {
  var theme = _ref3.theme,
      $isFilled = _ref3.$isFilled;
  return theme.normalizeStyles({
    top: 15,
    left: 28,
    fontSize: 18,
    lineHeight: 24,
    transition: '300ms',
    opacity: $isFilled ? 0 : 1,
    cursor: 'text'
  });
});

var InputLabel = function InputLabel(_ref4) {
  var name = _ref4.name,
      label = _ref4.label,
      rest = _objectWithoutProperties(_ref4, _excluded);

  return /*#__PURE__*/_jsxs(LabelWrapper, {
    children: [/*#__PURE__*/_jsx(Input, _objectSpread({
      id: name
    }, rest)), /*#__PURE__*/_jsx(Label, {
      htmlFor: name,
      $isFilled: !!rest.value,
      children: label
    })]
  });
};

export default InputLabel;